import { mapGetters } from 'vuex'

export default {
  ...mapGetters(['professional'])
}



// WEBPACK FOOTER //
// ./src/app/professional/dashboard/professional/gadget/components/schedulings/components/consultations-made/resources/computed.js